import React from 'react';

function About() {
  return (
    <div className="text-center">
      <h1 className="text-3xl font-bold mb-4">About Eccentric Stylist</h1>
      <p className="text-lg">Coming soon! In the meantime, feel free to read about me here!</p>
    </div>
  );
}

export default About;

